import React, { useState } from 'react';
import "../styles/screens/exampaperhub.css";
import { 
  FaSearch, 
  FaBook, 
  FaUniversity, 
  FaHome, 
  FaGraduationCap,
  FaFilePdf,
  FaDownload,
  FaChevronRight,
  FaChevronDown,
  FaBars,
  FaTimes
} from 'react-icons/fa';

// Sample exam data - structure can be expanded with actual data
const examData = {
  'UPSC': [
    {
      title: 'Civil Services Examination (CSE)',
      description: 'UPSC Civil Services Exam Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'General Studies Paper I', url: '/papers/upsc/2023/gs1.pdf' },
          { name: 'General Studies Paper II', url: '/papers/upsc/2023/gs2.pdf' },
          { name: 'General Studies Paper III', url: '/papers/upsc/2023/gs3.pdf' },
          { name: 'General Studies Paper IV', url: '/papers/upsc/2023/gs4.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'General Studies Paper I', url: '/papers/upsc/2022/gs1.pdf' },
          { name: 'General Studies Paper II', url: '/papers/upsc/2022/gs2.pdf' },
          { name: 'General Studies Paper III', url: '/papers/upsc/2022/gs3.pdf' },
          { name: 'General Studies Paper IV', url: '/papers/upsc/2022/gs4.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'General Studies Paper I', url: '/papers/upsc/2021/gs1.pdf' },
          { name: 'General Studies Paper II', url: '/papers/upsc/2021/gs2.pdf' },
          { name: 'General Studies Paper III', url: '/papers/upsc/2021/gs3.pdf' },
          { name: 'General Studies Paper IV', url: '/papers/upsc/2021/gs4.pdf' }
        ]}
      ]
    },
    {
      title: 'Engineering Services Examination',
      description: 'UPSC Engineering Services Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'General Studies & Engineering Aptitude', url: '/papers/upsc-ese/2023/paper1.pdf' },
          { name: 'Civil Engineering Paper I', url: '/papers/upsc-ese/2023/civil1.pdf' },
          { name: 'Civil Engineering Paper II', url: '/papers/upsc-ese/2023/civil2.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'General Studies & Engineering Aptitude', url: '/papers/upsc-ese/2022/paper1.pdf' },
          { name: 'Civil Engineering Paper I', url: '/papers/upsc-ese/2022/civil1.pdf' },
          { name: 'Civil Engineering Paper II', url: '/papers/upsc-ese/2022/civil2.pdf' }
        ]}
      ]
    }
  ],
  'GATE': [
    {
      title: 'Computer Science (CS)',
      description: 'GATE Computer Science Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Computer Science Paper', url: '/papers/gate/2023/cs.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Computer Science Paper', url: '/papers/gate/2022/cs.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Computer Science Paper', url: '/papers/gate/2021/cs.pdf' }
        ]},
        { year: '2020', papers: [
          { name: 'Computer Science Paper', url: '/papers/gate/2020/cs.pdf' }
        ]}
      ]
    },
    {
      title: 'Electrical Engineering (EE)',
      description: 'GATE Electrical Engineering Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Electrical Engineering Paper', url: '/papers/gate/2023/ee.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Electrical Engineering Paper', url: '/papers/gate/2022/ee.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Electrical Engineering Paper', url: '/papers/gate/2021/ee.pdf' }
        ]}
      ]
    }
  ],
  'IIT JAM': [
    {
      title: 'Mathematical Statistics (MS)',
      description: 'IIT JAM Mathematical Statistics Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Mathematical Statistics Paper', url: '/papers/iit-jam/2023/ms.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Mathematical Statistics Paper', url: '/papers/iit-jam/2022/ms.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Mathematical Statistics Paper', url: '/papers/iit-jam/2021/ms.pdf' }
        ]}
      ]
    },
    {
      title: 'Physics',
      description: 'IIT JAM Physics Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Physics Paper', url: '/papers/iit-jam/2023/physics.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Physics Paper', url: '/papers/iit-jam/2022/physics.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Physics Paper', url: '/papers/iit-jam/2021/physics.pdf' }
        ]}
      ]
    }
  ],
  'NEET': [
    {
      title: 'NEET UG',
      description: 'National Eligibility cum Entrance Test (Undergraduate) Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'NEET UG Paper', url: '/papers/neet/2023/neet-ug.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'NEET UG Paper', url: '/papers/neet/2022/neet-ug.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'NEET UG Paper', url: '/papers/neet/2021/neet-ug.pdf' }
        ]},
        { year: '2020', papers: [
          { name: 'NEET UG Paper', url: '/papers/neet/2020/neet-ug.pdf' }
        ]}
      ]
    }
  ],
  'CSIR NET': [
    {
      title: 'Life Sciences',
      description: 'CSIR NET Life Sciences Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Life Sciences Paper', url: '/papers/csir-net/2023/life-sciences.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Life Sciences Paper', url: '/papers/csir-net/2022/life-sciences.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Life Sciences Paper', url: '/papers/csir-net/2021/life-sciences.pdf' }
        ]}
      ]
    },
    {
      title: 'Chemical Sciences',
      description: 'CSIR NET Chemical Sciences Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Chemical Sciences Paper', url: '/papers/csir-net/2023/chemical-sciences.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Chemical Sciences Paper', url: '/papers/csir-net/2022/chemical-sciences.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Chemical Sciences Paper', url: '/papers/csir-net/2021/chemical-sciences.pdf' }
        ]}
      ]
    }
  ],
  'JEE': [
    {
      title: 'JEE Main',
      description: 'Joint Entrance Examination Main Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Paper 1 - January Session', url: '/papers/jee/2023/main-p1-jan.pdf' },
          { name: 'Paper 1 - April Session', url: '/papers/jee/2023/main-p1-apr.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Paper 1 - January Session', url: '/papers/jee/2022/main-p1-jan.pdf' },
          { name: 'Paper 1 - April Session', url: '/papers/jee/2022/main-p1-apr.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Paper 1 - February Session', url: '/papers/jee/2021/main-p1-feb.pdf' },
          { name: 'Paper 1 - March Session', url: '/papers/jee/2021/main-p1-mar.pdf' },
          { name: 'Paper 1 - July Session', url: '/papers/jee/2021/main-p1-jul.pdf' }
        ]}
      ]
    },
    {
      title: 'JEE Advanced',
      description: 'Joint Entrance Examination Advanced Previous Year Papers',
      years: [
        { year: '2023', papers: [
          { name: 'Paper 1', url: '/papers/jee/2023/advanced-p1.pdf' },
          { name: 'Paper 2', url: '/papers/jee/2023/advanced-p2.pdf' }
        ]},
        { year: '2022', papers: [
          { name: 'Paper 1', url: '/papers/jee/2022/advanced-p1.pdf' },
          { name: 'Paper 2', url: '/papers/jee/2022/advanced-p2.pdf' }
        ]},
        { year: '2021', papers: [
          { name: 'Paper 1', url: '/papers/jee/2021/advanced-p1.pdf' },
          { name: 'Paper 2', url: '/papers/jee/2021/advanced-p2.pdf' }
        ]}
      ]
    }
  ]
};

const ExamPapersHub = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSubject, setSelectedSubject] = useState(Object.keys(examData)[0]);
  const [selectedExamIndex, setSelectedExamIndex] = useState(0);
  const [expandedYears, setExpandedYears] = useState({});
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  // Get the selected exam
  const selectedExamList = examData[selectedSubject] || [];
  const selectedExam = selectedExamList[selectedExamIndex] || null;

  // Filter papers based on search term
  const filteredPapers = selectedExam?.years.map(yearData => {
    return {
      ...yearData,
      papers: yearData.papers.filter(paper => 
        paper.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        yearData.year.toLowerCase().includes(searchTerm.toLowerCase())
      )
    };
  }).filter(yearData => yearData.papers.length > 0) || [];

  // Toggle year expansion
  const toggleYearExpansion = (year) => {
    setExpandedYears(prev => ({
      ...prev,
      [year]: !prev[year]
    }));
  };

  // Handle subject change
  const handleSubjectChange = (subject) => {
    setSelectedSubject(subject);
    setSelectedExamIndex(0);
    setMobileMenuOpen(false);
  };

  // Handle exam change
  const handleExamChange = (index) => {
    setSelectedExamIndex(index);
  };

  // Handle paper download
  const handleDownloadPaper = (url) => {
    window.open(url, '_blank');
  };

  return (
    <div className="exam-papers-hub py-4 my-4">
      {/* Mobile Menu Toggle */}
      <div className="mobile-menu-toggle">
        <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          <span>Menu</span>
        </button>
      </div>

      {/* Left Sidebar */}
      <div className={`sidebar ${mobileMenuOpen ? 'mobile-open' : ''}`}>
        {/* App Title */}
        <div className="app-title">
          <FaGraduationCap className="app-icon" />
          <h1>PYQ Portal</h1>
        </div>

        {/* Search Bar */}
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search papers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* Navigation Menu */}
        <nav className="nav-menu">
          <div className="menu-header">MAIN MENU</div>
          <a href="/" className="nav-item">
            <FaHome className="nav-icon" /> 
            <span>Dashboard</span>
          </a>
          <a href="/" className="nav-item active">
            <FaBook className="nav-icon" /> 
            <span>Previous Year Papers</span>
          </a>
          <a href="/" className="nav-item">
            <FaUniversity className="nav-icon" /> 
            <span>Mock Tests</span>
          </a>

          {/* Exams Section */}
          <div className="menu-header">COMPETITIVE EXAMS</div>
          <div className="subject-list">
            {Object.keys(examData).map(subject => (
              <button
                key={subject} 
                className={`subject-item ${selectedSubject === subject ? 'active' : ''}`}
                onClick={() => handleSubjectChange(subject)}
              >
                <FaBook className="subject-icon" />
                <span>{subject}</span>
              </button>
            ))}
          </div>
        </nav>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Content Header */}
        <header className="content-header">
          <h2>{selectedSubject} Previous Year Papers</h2>
        </header>

        {/* Main Content Area */}
        <main className="papers-container">
          <div className="papers-layout">
            {/* Exams Sidebar */}
            <div className="exams-sidebar">
              <h3>Available Exams</h3>
              <div className="exam-list">
                {selectedExamList.map((exam, index) => (
                  <button
                    key={index}
                    className={`exam-item ${selectedExamIndex === index ? 'active' : ''}`}
                    onClick={() => handleExamChange(index)}
                  >
                    <div className="exam-title">{exam.title}</div>
                    <div className="exam-count">{exam.years.length} years available</div>
                  </button>
                ))}
              </div>
            </div>

            {/* Selected Exam Content */}
            <div className="exam-content">
              {selectedExam ? (
                <>
                  {/* Exam Header */}
                  <div className="exam-header">
                    <div className="exam-icon">
                      <FaBook />
                    </div>
                    <div>
                      <h2>{selectedExam.title}</h2>
                      <p>{selectedExam.description}</p>
                    </div>
                  </div>

                  {/* Papers Section */}
                  <div className="papers-section">
                    <h3>Previous Year Papers</h3>
                    
                    {filteredPapers.length > 0 ? (
                      <div className="year-list">
                        {filteredPapers.map((yearData) => (
                          <div key={yearData.year} className="year-container">
                            <button 
                              className="year-header" 
                              onClick={() => toggleYearExpansion(yearData.year)}
                            >
                              <span className="year-title">{yearData.year}</span>
                              {expandedYears[yearData.year] ? <FaChevronDown /> : <FaChevronRight />}
                            </button>
                            
                            {expandedYears[yearData.year] && (
                              <div className="papers-grid">
                                {yearData.papers.map((paper, index) => (
                                  <button 
                                    key={index} 
                                    className="paper-card"
                                    onClick={() => handleDownloadPaper(paper.url)}
                                  >
                                    <div className="paper-icon">
                                      <FaFilePdf />
                                    </div>
                                    <div className="paper-info">
                                      <span className="paper-name">{paper.name}</span>
                                      <span className="paper-year">{yearData.year}</span>
                                    </div>
                                    <div className="download-icon">
                                      <FaDownload />
                                    </div>
                                  </button>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="no-results">
                        <p>No papers found matching "{searchTerm}"</p>
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="no-exam-selected">
                  <p>Please select an exam to view papers</p>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ExamPapersHub;